/*=========================================================================================
  File Name: moduleAttackGetters.js
  Description: Attack Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    getAttacks: state => state.attacks,
    getAttackDetails: state => state.attackDetails,
    getWebhooks: state => state.webHooks,
    getdroppedEvents: state => state.droppedEvents,
};
  